import { useEffect, useState } from "react";
import { fetchController } from "../../utils/FetchController/fetchController";
import { getHostDomain } from "../../utils/utils";

const DEFAULT = { allocated: {}, utilized: {} };

export default function useUserCredits() {
  const baseUrl = getHostDomain();
  const [credits, setCredits] = useState(DEFAULT);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    (async () => {
      setStatus("loading");
      try {
        const res = await fetchController(`${baseUrl}/api/v1/analytics/user_credits`, "GET");
        setCredits(res || DEFAULT);
      } catch {
        setCredits(DEFAULT);
      } finally {
        setStatus("idle");
      }
    })();
  }, [baseUrl]);

  return { credits, status };
}
